import { render, staticRenderFns } from "./CircleButton.vue?vue&type=template&id=2552fa4b&"
import script from "./CircleButton.vue?vue&type=script&lang=js&"
export * from "./CircleButton.vue?vue&type=script&lang=js&"
import style0 from "./CircleButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports